<template>
    <modal :id="id" :title="title" size="md" @shown="shown">
        <template v-if="data.image">
            <img :src="data.image.url" class="img-fluid" width="100%" alt="...">
        </template>
        <template slot="modal-footer">
            <div></div>
        </template>
    </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";

export default {
    name: "FullImageModal",
    props: ['id'],
    components: {
        Modal,
    },
    data() {
        return {
            title: '',
            data: {}
        }
    },
    methods: {
        shown() {
            const { Medium } = this.$FeathersVuex;
            let data = Medium.getFromStore('temp');

            if (data) {
                delete data._id;
                this.data = this.$copy(data.image);
                new Medium({
                    model: {},
                    _id: 'temp'
                });
            }
        }
    }
}
</script>
